<app-section-quick-actions section="event" />

<header class="atmos-page__header">
  <h1 class="atmos-page__title">Event history</h1>
</header>

<div class="atmos-card atmos-event-history__grid-card">
  <ag-grid-angular [rowData]="rowData" [columnDefs]="colDefs" [theme]="theme"
    [getRowHeight]="getRowHeight" [suppressDragLeaveHidesColumns]="true"
    (gridReady)="onGridReady($event)" />
</div>
